import { supabase } from './supabase'

// ── postFn / authHeaders ─────────────────────────────────────────────────────
// Attach the signed-in user's Supabase JWT to a Netlify-function POST so the
// function can verify identity server-side. Functions must NEVER trust a user
// id supplied in the request body — they derive it from this token instead.
//
// postFn returns the raw fetch Response, so it is a drop-in replacement for
// fetch(path, { method:'POST', headers, body: JSON.stringify(payload) }).
export async function postFn(path, payload) {
  const headers = await authHeaders()
  return fetch(path, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload || {}),
  })
}

// Header object with the bearer token attached — for callers that compose their
// own fetch options (e.g. via safeCallFn).
export async function authHeaders() {
  let token
  try { token = (await supabase.auth.getSession())?.data?.session?.access_token } catch {}
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }
}
